import { render, staticRenderFns } from "./mallOrder.vue?vue&type=template&id=3b7fba6f&"
import script from "./mallOrder.vue?vue&type=script&lang=js&"
export * from "./mallOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports